// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__JkSvY","icon":"styles_icon__2Dfsy","active":"styles_active__IVfbt"};